import { render, staticRenderFns } from "./BaseBreadcrumbs.vue?vue&type=template&id=0c38409f&scoped=true&"
import script from "./BaseBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./BaseBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./BaseBreadcrumbs.vue?vue&type=style&index=0&id=0c38409f&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c38409f",
  null
  
)

export default component.exports